import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from '../../../../services/message-service/message.service';
import { FormControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { KienePatternUtils } from '../../../../utils/KienePatternUtils';
import { MatRadioChange } from '@angular/material/radio';
import { RegistrierungService } from '../../../registrierung/registrierung.service';
import { VvvoBasisInfosFormComponent } from '../vvvo-basis-infos-form/vvvo-basis-infos-form.component';
import { Client } from '../../../client/classes/client';
import { KieneUtils } from '../../../../utils/KieneUtils';
import { StammdatenService } from '../../stammdaten.service';
import { Subscription } from 'rxjs';
import { HitLoginResponse } from '../../../../hit/hit-registrierung/classes/hit-login-response';
import { HitService } from '../../../../hit/hit.service';

@Component({
    selector: 'vvvo-details',
    templateUrl: './vvvo-details.component.html',
    styleUrls: ['./vvvo-details.component.scss'],
})
export class VvvoDetailsComponent implements OnInit, OnDestroy, OnChanges {
    @Input() isDialog = false;
    @Input() emailRequired = true;
    @Output() save = new EventEmitter<Client>();

    kundeSubscription: Subscription;
    @Input() public kunde: Client;
    kundeId: number;
    redirectTo = '../../';
    hitLoginResponse: HitLoginResponse;
    saveText = 'Einstellungen speichern';
    kontoinhaberCtrl: UntypedFormControl = new UntypedFormControl(null, [
        Validators.required,
        Validators.pattern(KienePatternUtils.NAME()),
    ]);
    kreditinstitutCtrl: UntypedFormControl = new UntypedFormControl(null, [
        Validators.required,
        Validators.pattern(KienePatternUtils.NAME()),
    ]);
    ibanCtrl: UntypedFormControl = new UntypedFormControl(null, [
        Validators.required,
        Validators.pattern(KienePatternUtils.IBAN_INTERNATIONAL()),
    ]);
    rechnungsOptionenCtrl: UntypedFormControl = new UntypedFormControl(null, [Validators.required]);
    lastschriftFormGroup: UntypedFormGroup = new UntypedFormGroup({
        kontoinhaberCtrl: this.kontoinhaberCtrl,
        kreditinstitutCtrl: this.kreditinstitutCtrl,
        ibanCtrl: this.ibanCtrl,
    });
    abweichendeLieferadresseCtrl: UntypedFormControl = new UntypedFormControl(null, [Validators.required]);
    abweichendeLieferadresseStrasse: UntypedFormControl = new UntypedFormControl(null, [Validators.required]);
    abweichendeLieferadressePlz: UntypedFormControl = new UntypedFormControl(null, [
        Validators.required,
        Validators.pattern(KienePatternUtils.PLZ()),
    ]);
    abweichendeLieferadresseOrt: UntypedFormControl = new UntypedFormControl(null, [Validators.required]);
    abweichendeLieferadresseOrtsteil: UntypedFormControl = new UntypedFormControl(null);
    abweichendeLieferadresseFormGroup: UntypedFormGroup = new UntypedFormGroup({
        abweichendeLieferadresseStrasse: this.abweichendeLieferadresseStrasse,
        abweichendeLieferadressePlz: this.abweichendeLieferadressePlz,
        abweichendeLieferadresseOrt: this.abweichendeLieferadresseOrt,
        abweichendeLieferadresseOrtsteil: this.abweichendeLieferadresseOrtsteil,
    });
    abweichendeRechnungsadresseCtrl: UntypedFormControl = new UntypedFormControl(Validators.required);
    rechnungsaddresseVornameCtrl: UntypedFormControl = new UntypedFormControl(null, [
        Validators.pattern(KienePatternUtils.NAME()),
    ]);
    rechnungsaddresseNachnameCtrl: UntypedFormControl = new UntypedFormControl(null, [
        Validators.pattern(KienePatternUtils.NAME()),
    ]);
    rechnungsaddresseStrasseCtrl: UntypedFormControl = new UntypedFormControl(null, []);
    rechnungsaddressePlzCtrl: UntypedFormControl = new UntypedFormControl(null, [
        Validators.pattern(KienePatternUtils.PLZ()),
    ]);
    rechnungsaddresseOrtCtrl: UntypedFormControl = new UntypedFormControl(null, [
        Validators.pattern(KienePatternUtils.NAME()),
    ]);
    rechnungsaddresseOrtsteilCtrl: UntypedFormControl = new UntypedFormControl(null, [
        Validators.pattern(KienePatternUtils.NAME()),
    ]);
    rechnungsaddresseFormGroup: UntypedFormGroup = new UntypedFormGroup({
        rechnungsaddresseVornameCtrl: this.rechnungsaddresseVornameCtrl,
        rechnungsaddresseNachnameCtrl: this.rechnungsaddresseNachnameCtrl,
        rechnungsaddresseStrasseCtrl: this.rechnungsaddresseStrasseCtrl,
        rechnungsaddressePlzCtrl: this.rechnungsaddressePlzCtrl,
        rechnungsaddresseOrtCtrl: this.rechnungsaddresseOrtCtrl,
        rechnungsaddresseOrtsteilCtrl: this.rechnungsaddresseOrtsteilCtrl,
    });
    abweichendeEmailCtrl: UntypedFormControl = new UntypedFormControl(null, [
        Validators.pattern(KienePatternUtils.EMAIL()),
    ]);
    perPostCtrl: UntypedFormControl = new UntypedFormControl(null, []);
    perEmailCtrl: UntypedFormControl = new UntypedFormControl(null, []);

    bestandsbuchDigitalCtrl: UntypedFormControl = new FormControl(undefined, [Validators.required]);
    ohrmarkenNachAbteilGruppierenCtrl: FormControl = new FormControl(false);
    ersteinrichtung = false;
    @ViewChild('basisInfos')
    private readonly basisInfos: VvvoBasisInfosFormComponent;

    constructor(
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly messageService: MessageService,
        private readonly stammdatenService: StammdatenService,
        private readonly registrierungService: RegistrierungService,
        private readonly hitService: HitService,
    ) {}

    ngOnDestroy(): void {
        this.kundeSubscription?.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['kunde'] && changes['kunde'].currentValue) {
            this.setDefaults();
            this.setKundeInForm();
        }
    }

    ngOnInit(): void {
        if (this.isDialog) {
            // Desktop-Dialog (Profil → Betriebe → Plus): PIN aus HitService nachziehen,
            // sonst fehlt sie in setCtrlsInKunde() und wird nicht mitgespeichert.
            if (this.hitService.hasHitLoggedIn()) {
                this.hitLoginResponse = this.hitService.getHitLoginResponse();
                if (this.hitLoginResponse?.pin && this.kunde && !this.kunde.pin) {
                    this.kunde.pin = this.hitLoginResponse.pin;
                }
            }
            if (this.kunde) {
                this.setDefaults();
                this.setKundeInForm();
                this.initFormControls();
            }
            return;
        }

        this.route.queryParams.subscribe(params => {
            if (params.ersteinrichtung) {
                this.ersteinrichtung = true;
                this.redirectTo = '../../';
                this.saveText = 'VVVO hinzufügen';
            }
        });

        this.route.params.subscribe(params => {
            if (params.id) {
                this.kundeId = params.id;
                this.loadKunde();
            } else if (this.hitService.hasHitLoggedIn()) {
                // neue HIT VVVO hinzugefügt - pin an Backend senden
                this.hitLoginResponse = this.hitService.getHitLoginResponse();
                this.kunde = HitLoginResponse.generateClient(this.hitLoginResponse);
                this.setDefaults();
                this.setKundeInForm();
                this.initFormControls();
            } else {
                this.router.navigate(['../uebersicht'], { relativeTo: this.route }).then();
            }
        });
    }

    /**
     * Setzt die Defaultwerte für die Kundendaten, wenn keine Daten vorhanden sind.
     * <strong>Tierbewegung_melden immer auf 1 setzen.</strong>
     */
    setDefaults() {
        this.kunde.tierbewegung_melden = 1;

        if (!this.kunde.kp_abw_rechnungsadresse) {
            this.kunde.kp_abw_rechnungsadresse = 0;
        }
        if (!this.kunde.abweichende_lieferadresse) {
            this.kunde.abweichende_lieferadresse = 0;
        }
        if (!this.kunde.kp_lastschrift) {
            this.kunde.kp_lastschrift = 0;
        }
        if (!this.kunde.kp_rechnung_post) {
            this.kunde.kp_rechnung_post = 0;
        }
        if (!this.kunde.kp_rechnung_email) {
            this.kunde.kp_rechnung_email = 1;
        }

        if (!KieneUtils.isApiOne(this.kunde.bestandsbuch_digital)) {
            this.kunde.bestandsbuch_digital = 0;
        }
        if (!KieneUtils.isApiOne(this.kunde.beleg_abteil_gruppieren)) {
            this.kunde.beleg_abteil_gruppieren = 0;
        }
    }

    loadKunde() {
        this.kundeSubscription?.unsubscribe();
        this.kundeSubscription = this.stammdatenService.getKunde(this.kundeId).subscribe({
            next: kunde => {
                this.kunde = kunde;
                this.setDefaults();
                this.setKundeInForm();
                this.initFormControls();
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Laden der VVVO', err);
            },
        });
    }

    setKundeInForm() {
        // Abweichende Lieferadresse
        this.setAbweichendeLieferadresseInForm();

        // Abrechnung
        this.setAbrechnungInForm();

        // Ohrmarken nach Abteil gruppieren
        this.ohrmarkenNachAbteilGruppierenCtrl.setValue(KieneUtils.isApiOne(this.kunde.beleg_abteil_gruppieren));
        this.bestandsbuchDigitalCtrl.setValue(this.kunde.bestandsbuch_digital);
    }

    isBestandsbuchDigital(): boolean {
        return KieneUtils.isApiOne(this.kunde?.bestandsbuch_digital);
    }

    setAbweichendeLieferadresseInForm() {
        this.abweichendeLieferadresseCtrl.setValue(KieneUtils.isApiOne(this.kunde.abweichende_lieferadresse));

        this.abweichendeLieferadresseStrasse.setValue(this.kunde.strasse_lieferung);
        this.abweichendeLieferadressePlz.setValue(this.kunde.plz_lieferung);
        this.abweichendeLieferadresseOrt.setValue(this.kunde.ort_lieferung);
        this.abweichendeLieferadresseOrtsteil.setValue(this.kunde.ortsteil_lieferung);

        this.triggerAbweichendeLieferadresseCtrls(this.kunde.abweichende_lieferadresse);
    }

    setAbrechnungInForm() {
        // Allg.
        this.rechnungsOptionenCtrl.setValue(this.kunde.kp_lastschrift);

        // per Rechnung - Abweichende Rechnungsadresse
        this.abweichendeRechnungsadresseCtrl.setValue(KieneUtils.isApiOne(this.kunde.kp_abw_rechnungsadresse));

        this.rechnungsaddresseVornameCtrl.setValue(this.kunde.kp_abw_rechnungsadresse_vorname);
        this.rechnungsaddresseNachnameCtrl.setValue(this.kunde.kp_abw_rechnungsadresse_nachname);
        this.rechnungsaddresseStrasseCtrl.setValue(this.kunde.kp_abw_rechnungsadresse_strasse);
        this.rechnungsaddressePlzCtrl.setValue(this.kunde.kp_abw_rechnungsadresse_plz);
        this.rechnungsaddresseOrtCtrl.setValue(this.kunde.kp_abw_rechnungsadresse_ort);
        this.rechnungsaddresseOrtsteilCtrl.setValue(this.kunde.kp_abw_rechnungsadresse_ortsteil);
        this.triggerAbweichendeRechnungsadresseCtrls(this.kunde.kp_abw_rechnungsadresse);

        // per Lastschrift
        this.kontoinhaberCtrl.setValue(this.kunde.kp_kontoinhaber);
        this.kreditinstitutCtrl.setValue(this.kunde.kp_kreditinstitut);
        this.ibanCtrl.setValue(this.kunde.kp_iban);

        this.triggerLastschriftCtrls(this.kunde.kp_lastschrift);

        // Rechnungszustellung
        this.perPostCtrl.setValue(KieneUtils.isApiOne(this.kunde.kp_rechnung_post));
        this.perEmailCtrl.setValue(KieneUtils.isApiOne(this.kunde.kp_rechnung_email));
        this.abweichendeEmailCtrl.setValue(this.kunde.kp_abw_email);

        this.triggerRechnungszustellungCtrls(this.kunde.kp_rechnung_email);
    }

    initFormControls() {
        this.rechnungsOptionenCtrl.valueChanges.subscribe(valueChanges => {
            this.kunde.kp_lastschrift = valueChanges;
            this.triggerLastschriftCtrls(this.kunde.kp_lastschrift);
        });

        this.abweichendeRechnungsadresseCtrl.valueChanges.subscribe(valueChanges => {
            if (valueChanges) {
                this.kunde.kp_abw_rechnungsadresse = 1;
                this.rechnungsaddresseFormGroup.enable();
            } else {
                this.kunde.kp_abw_rechnungsadresse = 0;
                this.rechnungsaddresseFormGroup.disable();
            }
        });

        this.abweichendeLieferadresseCtrl.valueChanges.subscribe(valueChanges => {
            if (valueChanges) {
                this.kunde.abweichende_lieferadresse = 1;
                this.abweichendeLieferadresseFormGroup.enable();
            } else {
                this.kunde.abweichende_lieferadresse = 0;
                this.abweichendeLieferadresseFormGroup.disable();
            }
        });

        this.perEmailCtrl.valueChanges.subscribe(valueChanges => {
            valueChanges ? this.abweichendeEmailCtrl.enable() : this.abweichendeEmailCtrl.disable();
        });
    }

    updateKunde() {
        this.setCtrlsInKunde();

        const pinToPersist = this.kunde?.pin;
        const isNewBetrieb = !this.kunde?.kunde_id;
        this.stammdatenService.saveKunde(this.kunde).subscribe({
            next: resp => {
                // Nur bei neuem Betrieb: PIN zusätzlich dediziert speichern (wie manueller Workaround).
                const kundeId = Number(resp?.kunde_id || this.kunde?.kunde_id || 0);
                if (isNewBetrieb && kundeId > 0 && pinToPersist) {
                    this.stammdatenService.hitPinAendern(kundeId, pinToPersist).subscribe({
                        next: () => this.afterKundeSaved(resp),
                        error: err => {
                            this.messageService.errorMessage(
                                'Betrieb gespeichert, aber HIT-PIN konnte nicht hinterlegt werden. Bitte „HIT-PIN aktualisieren“ nutzen.',
                                err,
                            );
                            this.afterKundeSaved(resp);
                        },
                    });
                    return;
                }
                this.afterKundeSaved(resp);
            },
            error: err => {
                this.messageService.errorMessage('Fehler: VVVO konnte nicht aktualisiert werden.', err);
            },
        });
    }

    private afterKundeSaved(resp: Client): void {
        this.stammdatenService.setAktualisierteVvvo(resp);
        this.messageService.infoMessage('VVVO wurde aktualisiert.');
        this.registrierungService.addVvvoErsteinrichtung();

        if (!this.isDialog) {
            if (this.kundeId) {
                this.redirectTo = '../../';
            } else {
                this.redirectTo = '../';
            }
            this.router.navigate([this.redirectTo], { relativeTo: this.route }).then();
        } else {
            this.save.emit(resp);
        }
    }

    setCtrlsInKunde() {
        if (!this.hitLoginResponse?.pin && this.hitService.hasHitLoggedIn()) {
            this.hitLoginResponse = this.hitService.getHitLoginResponse();
        }
        if (this.hitLoginResponse?.pin) {
            this.kunde.pin = this.hitLoginResponse.pin;
        }

        this.kunde.kp_kontoinhaber = this.kontoinhaberCtrl.value;
        this.kunde.kp_kreditinstitut = this.kreditinstitutCtrl.value;
        this.kunde.kp_iban = this.ibanCtrl.value;
        if (this.kunde.kp_lastschrift) {
            this.kunde.kp_lastschrift = this.rechnungsOptionenCtrl.value;
        }

        this.kunde.abweichende_lieferadresse = this.abweichendeLieferadresseCtrl.value ? 1 : 0;
        this.kunde.strasse_lieferung = this.abweichendeLieferadresseStrasse.value;
        this.kunde.plz_lieferung = this.abweichendeLieferadressePlz.value;
        this.kunde.ort_lieferung = this.abweichendeLieferadresseOrt.value;
        this.kunde.ortsteil_lieferung = this.abweichendeLieferadresseOrtsteil.value;

        this.kunde.kp_abw_rechnungsadresse = this.abweichendeRechnungsadresseCtrl.value ? 1 : 0;
        this.kunde.kp_abw_rechnungsadresse_vorname = this.rechnungsaddresseVornameCtrl.value;
        this.kunde.kp_abw_rechnungsadresse_nachname = this.rechnungsaddresseNachnameCtrl.value;
        this.kunde.kp_abw_rechnungsadresse_strasse = this.rechnungsaddresseStrasseCtrl.value;
        this.kunde.kp_abw_rechnungsadresse_plz = this.rechnungsaddressePlzCtrl.value;
        this.kunde.kp_abw_rechnungsadresse_ort = this.rechnungsaddresseOrtCtrl.value;
        this.kunde.kp_abw_rechnungsadresse_ortsteil = this.rechnungsaddresseOrtsteilCtrl.value;
        
        this.kunde.beleg_abteil_gruppieren = this.ohrmarkenNachAbteilGruppierenCtrl.value ? 1 : 0;

        this.kunde.kp_rechnung_post = this.perPostCtrl.value ? 1 : 0;
        this.kunde.kp_rechnung_email = this.perEmailCtrl.value ? 1 : 0;
        this.kunde.kp_abw_email = this.abweichendeEmailCtrl.value;
    }

    triggerLastschriftCtrls(lastschriftEnable: unknown) {
        if (KieneUtils.isApiOne(lastschriftEnable)) {
            this.lastschriftFormGroup.enable();
        } else {
            this.lastschriftFormGroup.disable();
        }
    }

    triggerAbweichendeRechnungsadresseCtrls(abweichendeRechnungsadresseEnable: unknown) {
        if (KieneUtils.isApiOne(abweichendeRechnungsadresseEnable)) {
            this.rechnungsaddresseFormGroup.enable();
        } else {
            this.rechnungsaddresseFormGroup.disable();
        }
    }

    triggerAbweichendeLieferadresseCtrls(abweichendeLieferadresseEnable: unknown) {
        if (KieneUtils.isApiOne(abweichendeLieferadresseEnable)) {
            this.abweichendeLieferadresseFormGroup.enable();
        } else {
            this.abweichendeLieferadresseFormGroup.disable();
        }
    }

    allFormsValid() {
        let valid = this.basisInfos?.areCtrlsValid();
        valid = valid && KieneUtils.isNNoU(this.kunde.bestandsbuch_digital);
        return valid;
    }

    changeBestandsbuchDigital(event: MatRadioChange) {
        const bestandsbuch_digital: number = event.value;
        if (this.kunde) {
            this.kunde.bestandsbuch_digital = bestandsbuch_digital;
        }
    }

    private triggerRechnungszustellungCtrls(kp_rechnung_email: unknown) {
        if (KieneUtils.isApiOne(kp_rechnung_email)) {
            this.abweichendeEmailCtrl.enable();
        } else {
            this.abweichendeEmailCtrl.disable();
        }
    }
}
